(function () {
  const localisationWrapper = document.querySelector('#localisation-list.footer-bar__list');
  const localisationButton = document.querySelector('#localisation-footer.footer-bar__button');
  if (!localisationWrapper || !localisationButton || localisationWrapper instanceof HTMLElement === false) {
    return;
  }

  localisationButton.addEventListener('click', (event) => {
    event.stopPropagation();

    if (localisationWrapper.hasAttribute('open')) {
      localisationWrapper.removeAttribute('open');
      localisationWrapper.style.maxHeight = '';
    } else {
      localisationWrapper.setAttribute('open', '');
      localisationWrapper.style.maxHeight = localisationWrapper.scrollHeight + 'px';
    }
  });

  document.addEventListener('click', (e) => {
    if (localisationWrapper.hasAttribute('open')) {
      localisationWrapper.removeAttribute('open');
    }
  });
})();
